import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useApolloClient } from 'react-apollo-hooks';
import { GET_MEMBER } from '../common/graphql/GetMember';
import Splasher from '../components/Splasher';
import get from 'lodash/get';
import { adminGroupName } from './../config';
import authError from '../common/error/Authentication';

export const UserContext = React.createContext();

export function Provider(props) {
  const [currentUser, setCurrentUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [signingIn, setSigningIn] = React.useState(false);
  const [error, setError] = useState({ code: null, message: null, hasError: false });
  const [forceChangeUser, setForceChangeUser] = React.useState(null);
  const [lastPath, setLastPath] = React.useState(null);
  const client = useApolloClient();

  const handleSuccessAuth = async result => {
    const data = await client.query({
      query: GET_MEMBER.query,
      variables: {
        memberId: result.username,
      },
      fetchPolicy: 'network-only',
    });
    let memberInfo = get(data, 'data.getMember');
    let roles = get(data, 'data.listRoles.items', []);
    if (!memberInfo) {
      const groups = get(
        result,
        ['signInUserSession', 'idToken', 'payload', 'cognito:groups'],
        [],
      );
      const email = get(result, ['signInUserSession', 'idToken', 'payload', 'email']);
      if (groups.includes(adminGroupName)) {
        memberInfo = {
          email,
          firstName: 'adm',
          lastName: email,
          role: {
            group: adminGroupName,
          },
        };
      }
    }

    const user = {
      ...result,
      memberInfo,
      roles,
    };
    console.log('USER ALREADY SIGNED IN: ', user);
    console.log('CURRENT PATH: ', lastPath);
    setCurrentUser(user);
  };

  const forceChangePass = async newPassword => {
    try {
      const result = await Auth.completeNewPassword(forceChangeUser, newPassword);
      console.log('Force change successful! ', result);
      await handleSuccessAuth(result);
    } catch (e) {
      console.log('SOMETHING WRONG SETTING NEW PASSWORD ', e);
      setError({ code: e.code, message: e.message, hasError: true });
    }
  };

  const fetchAuth = async () => {
    try {
      console.log('CHECKING IF ALREADY SIGNED IN: ', currentUser);
      const result = await Auth.currentAuthenticatedUser();
      console.log('CHECKED IF ALREADY SIGNED IN: ', result);
      const currentUserId = get(result, 'username');
      console.log('currentUserId', currentUserId); //TRACE
      await handleSuccessAuth(result);
    } catch (error) {
      console.error('ERROR TRYING TO CHECK IF ALREADY SIGNED IN: ', error);
    }
    setLoading(false);
  };

  const signIn = async (username, password) => {
    setSigningIn(true);
    try {
      console.log('SIGNING IN: ', currentUser);
      const result = await Auth.signIn(username, password);

      if (result.challengeName) {
        setForceChangeUser(result);
        throw Error(result.challengeName);
      }

      console.log('SIGNED IN: ', result);
      await handleSuccessAuth(result);
      setSigningIn(false);
    } catch (err) {
      console.log(err.code);
      console.log('ERROR SIGNING IN: ', err);
      setError({
        code: err.code ? err.code : err.message,
        message: authError(err.code || err.message || err),
        hasError: true,
      });
      setCurrentUser(null);
      setSigningIn(false);
    }
  };

  const signOut = async currentPath => {
    try {
      await Auth.signOut();
      console.log('CURRENT PATH: ', currentPath);
      setLastPath(currentPath);
      setCurrentUser(null);
    } catch (err) {
      setError({ hasError: true, code: err.code, message: authError(err.code) });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAuth();
  }, []);

  return (
    <UserContext.Provider
      value={{
        signingIn,
        setSigningIn,
        loading,
        currentUser,
        signIn,
        signOut,
        error,
        setError,
        setLoading,
        forceChangePass,
        lastPath,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
}

export default UserContext;
